// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/billing_new/dto_diagnocoin_new.proto (package com.diagnocat.billing_new, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { ServiceType } from "./dto_services_new_pb.js";
import { CalledVia, Created, DeletedNew, RevisionNew } from "../../model/dto_base_pb.js";

/**
 * @generated from enum com.diagnocat.billing_new.DiagnocoinBatchStatus
 */
export const DiagnocoinBatchStatus = proto3.makeEnum(
  "com.diagnocat.billing_new.DiagnocoinBatchStatus",
  [
    {no: 0, name: "DiagnocoinBatchStatusInvalidValue"},
    {no: 1, name: "DiagnocoinBatchStatusOpen"},
    {no: 2, name: "DiagnocoinBatchStatusExhausted"},
    {no: 3, name: "DiagnocoinBatchStatusExpired"},
    {no: 4, name: "DiagnocoinBatchStatusExpiredWithHolds"},
  ],
);

/**
 * @generated from enum com.diagnocat.billing_new.DiagnocoinLedgerEntryType
 */
export const DiagnocoinLedgerEntryType = proto3.makeEnum(
  "com.diagnocat.billing_new.DiagnocoinLedgerEntryType",
  [
    {no: 0, name: "DiagnocoinLedgerEntryTypeInvalidValue"},
    {no: 1, name: "DiagnocoinLedgerEntryTypeCredit"},
    {no: 2, name: "DiagnocoinLedgerEntryTypeReserve"},
    {no: 3, name: "DiagnocoinLedgerEntryTypeCommit"},
    {no: 4, name: "DiagnocoinLedgerEntryTypeRelease"},
    {no: 5, name: "DiagnocoinLedgerEntryTypeReleaseExpired"},
    {no: 6, name: "DiagnocoinLedgerEntryTypeExpire"},
    {no: 7, name: "DiagnocoinLedgerEntryTypeAdjustment"},
  ],
);

/**
 * DiagnocoinBucket is where coins sit inside a batch.
 *
 * Every coin of a batch is in exactly one bucket at any time, and
 * Total = Available + Reserved + Spent + Expired + AdjustedOut always holds.
 *
 * @generated from enum com.diagnocat.billing_new.DiagnocoinBucket
 */
export const DiagnocoinBucket = proto3.makeEnum(
  "com.diagnocat.billing_new.DiagnocoinBucket",
  [
    {no: 0, name: "DiagnocoinBucketInvalidValue"},
    {no: 1, name: "DiagnocoinBucketNone"},
    {no: 2, name: "DiagnocoinBucketAvailable"},
    {no: 3, name: "DiagnocoinBucketReserved"},
    {no: 4, name: "DiagnocoinBucketSpent"},
    {no: 5, name: "DiagnocoinBucketExpired"},
    {no: 6, name: "DiagnocoinBucketAdjustedOut"},
  ],
);

/**
 * DiagnocoinPrice is what one report of a given kind costs in coins.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinPrice
 */
export const DiagnocoinPrice = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinPrice",
  () => [
    { no: 1, name: "ServiceType", kind: "enum", T: proto3.getEnumType(ServiceType) },
    { no: 2, name: "Coins", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * DiagnocoinPriceList is the whole coin price catalog.
 *
 * It is global rather than per-account — every account pays the same — and is
 * pushed once when `AccountInfoStream` opens so a client can price a report
 * without a round trip per order.
 *
 * ONLY coin-payable services appear here. A service type absent from the list
 * cannot be paid for with coins at all, which callers must treat as "no coin
 * fallback for this one" and NEVER as a price of zero. That mirrors the
 * fail-closed rule the server applies when funding a report.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinPriceList
 */
export const DiagnocoinPriceList = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinPriceList",
  () => [
    { no: 1, name: "Prices", kind: "message", T: DiagnocoinPrice, repeated: true },
    { no: 2, name: "PriceTableVersion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ReferralRewards is what the referral program credits: coins for the clinic
 * that shared its link.
 *
 * The amount comes from the referral product of the account's billing zone,
 * the same product the referral webhook orders, so the widget and the accrual
 * never disagree.
 *
 * @generated from message com.diagnocat.billing_new.ReferralRewards
 */
export const ReferralRewards = proto3.makeMessageType(
  "com.diagnocat.billing_new.ReferralRewards",
  () => [
    { no: 1, name: "ReferrerCoins", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * DiagnocoinWallet is the account-level coin balance.
 *
 * Note it is keyed by billing ACCOUNT, which may span several organizations,
 * exactly like the product inventory it falls back from.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinWallet
 */
export const DiagnocoinWallet = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinWallet",
  () => [
    { no: 1, name: "AccountID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Available", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "Reserved", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "TotalUnspent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "LifetimeCredited", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "LifetimeSpent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "LifetimeExpired", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "LifetimeAdjustedOut", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10040, name: "Revision", kind: "message", T: RevisionNew },
  ],
);

/**
 * DiagnocoinBatch is one purchase of coins, with its own expiry.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinBatch
 */
export const DiagnocoinBatch = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinBatch",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AccountID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Available", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "Reserved", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "Spent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "Expired", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "AdjustedOut", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "Remaining", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "PurchasedAt", kind: "message", T: Timestamp },
    { no: 10, name: "ExpiresAt", kind: "message", T: Timestamp },
    { no: 11, name: "Status", kind: "enum", T: proto3.getEnumType(DiagnocoinBatchStatus) },
    { no: 12, name: "Purchase", kind: "message", T: DiagnocoinBatchPurchase },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: RevisionNew },
    { no: 10050, name: "Deleted", kind: "message", T: DeletedNew },
  ],
);

/**
 * DiagnocoinBatchPurchase links a batch back to the money that created it.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinBatchPurchase
 */
export const DiagnocoinBatchPurchase = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinBatchPurchase",
  () => [
    { no: 1, name: "OrderID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ProductSKU", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "CoinAmount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "FiatAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "FiatCurrency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * DiagnocoinLedgerDeltas is the WALLET-level signed movement of one entry: the
 * aggregate, regardless of which batches were involved.
 *
 * Summing these across the whole ledger must reproduce the wallet exactly. That
 * is the strongest invariant the reconciliation job checks, and it is what makes
 * the wallet a projection rather than a source of truth.
 *
 * Compare `DiagnocoinLedgerEntry.Allocations`, which is the same movement broken
 * down PER BATCH. The two must agree: for each bucket, the allocations leaving it
 * minus those entering it equals the delta for that bucket.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinLedgerDeltas
 */
export const DiagnocoinLedgerDeltas = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinLedgerDeltas",
  () => [
    { no: 1, name: "Credited", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "Available", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "Reserved", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Spent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "Expired", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "AdjustedOut", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * DiagnocoinAllocation records that `Amount` coins of ONE batch moved between two
 * buckets.
 *
 * This is the per-batch detail behind an entry's `Deltas`. It exists because a
 * wallet-level number cannot answer "which batch did this come out of", and FIFO
 * makes that the interesting question — a batch's expiry depends on when it was
 * bought, so it matters which one paid.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinAllocation
 */
export const DiagnocoinAllocation = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinAllocation",
  () => [
    { no: 1, name: "BatchID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "From", kind: "enum", T: proto3.getEnumType(DiagnocoinBucket) },
    { no: 4, name: "To", kind: "enum", T: proto3.getEnumType(DiagnocoinBucket) },
  ],
);

/**
 * DiagnocoinLedgerEntry is one immutable accounting record.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinLedgerEntry
 */
export const DiagnocoinLedgerEntry = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinLedgerEntry",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AccountID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Sequence", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "Type", kind: "enum", T: proto3.getEnumType(DiagnocoinLedgerEntryType) },
    { no: 6, name: "IdempotencyKey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Deltas", kind: "message", T: DiagnocoinLedgerDeltas },
    { no: 8, name: "Allocations", kind: "message", T: DiagnocoinAllocation, repeated: true },
    { no: 9, name: "Reference", kind: "message", T: DiagnocoinLedgerReference },
    { no: 10, name: "AvailableAfter", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "ReservedAfter", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "EffectiveAt", kind: "message", T: Timestamp },
    { no: 13, name: "RecordedAt", kind: "message", T: Timestamp },
    { no: 14, name: "ActorID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "ActorVia", kind: "enum", T: proto3.getEnumType(CalledVia) },
  ],
);

/**
 * DiagnocoinLedgerReference ties an entry to the business object behind it.
 *
 * Which fields are set depends on the entry type, and they are mutually exclusive
 * in practice: a credit references the purchase, a spend references the report.
 * Expiry entries reference neither — nobody asked for it, the clock did.
 *
 * @generated from message com.diagnocat.billing_new.DiagnocoinLedgerReference
 */
export const DiagnocoinLedgerReference = proto3.makeMessageType(
  "com.diagnocat.billing_new.DiagnocoinLedgerReference",
  () => [
    { no: 1, name: "OrderID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ConsumptionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ServiceType", kind: "enum", T: proto3.getEnumType(ServiceType) },
    { no: 4, name: "PriceTableVersion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

